import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { StorageKeys } from 'src/app/shared-module-files/simpo.constant';
@Injectable({
  providedIn: 'root'
})
export class StaffAccessServiceService {

  constructor(
    public dialog: MatDialog,
    private http: HttpClient,
    private snackbar: MatSnackBar,
  ) { }
  AssignRemoveStaff(businessId: any, data: any) {
    return this.http.put(
      environment.baseUrl + `staff/staff/${businessId}/assign-remove-staff`, data
    )
  }
  openSnack(message: any, action: any) {
    this.snackbar.open(message, action, { duration: 5000 });
  }
  getAssignStaffListing(businessId: any, pageNo: number, size: number, searchText: any) {
    return this.http.get(
      environment.baseUrl + `staff/staff/${businessId}/auto-enquiry-enabled/list?pageNo=${pageNo}&size=${size}&searchText=${searchText}`
    )
  }
  getStaffListingByStaffName(businessId: any, pageNo?: number, size?: number, status?: any, searchText?: any) {
    return this.http.get(
      environment.baseUrl + `staff/staff/list/${businessId}?page=${pageNo}&size=${size}&status=${status}&searchText=${searchText}`
    )
  }


  updateLeadAssignedStaff(leadId: string, staffId: string, staffName: string) {
  return this.http.patch(
      environment.baseUrl + `crm/leads/update`, null, {
    params: {
      leadId,
      staffId,
      staffName
    }
  });
}

}
